import { ShipmentDeliveryLineDto } from '@shared/src/dtos/shipment/delivery/ShipmentDeliveryLineDto';

/***
 * Payload del desat massiu de línies d'albarà. Els totals fixats manualment
 * viatgen sempre en aquest mateix "pack" (mateix botó de Guardar, mateix
 * "dirty" que les línies), no com una acció a part contra el servidor.
 */
export class ShipmentDeliveryLinesSaveDto {
    public shipmentId: number;
    public shipmentDeliveryId: number;
    public lines: ShipmentDeliveryLineDto[];

    public totalQuantityFixed: number;
    public totalQuantityIsFixed: boolean;
    public totalPriceFixed: number;
    public totalPriceIsFixed: boolean;
    public totalKgFixed: number;
    public totalKgIsFixed: boolean;
    public totalM3Fixed: number;
    public totalM3IsFixed: boolean;
    public totalPalletFixed: number;
    public totalPalletIsFixed: boolean;
    public totalNetKgFixed: number;
    public totalNetKgIsFixed: boolean;
    public totalBoxesFixed: number;
    public totalBoxesIsFixed: boolean;
    public totalBagsFixed: number;
    public totalBagsIsFixed: boolean;
    public totalSacksFixed: number;
    public totalSacksIsFixed: boolean;
    public totalLitresFixed: number;
    public totalLitresIsFixed: boolean;
}
